import { render, staticRenderFns } from "./LicenseInformation.vue?vue&type=template&id=e9e8efbc&scoped=true"
import script from "./LicenseInformation.vue?vue&type=script&lang=js"
export * from "./LicenseInformation.vue?vue&type=script&lang=js"
import style0 from "./LicenseInformation.vue?vue&type=style&index=0&id=e9e8efbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e8efbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9e8efbc')) {
      api.createRecord('e9e8efbc', component.options)
    } else {
      api.reload('e9e8efbc', component.options)
    }
    module.hot.accept("./LicenseInformation.vue?vue&type=template&id=e9e8efbc&scoped=true", function () {
      api.rerender('e9e8efbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/LicenseInformation.vue"
export default component.exports